/**
 * Sometimes, you will find backticks in the description. It would be fine if it was markdown,
 * but the rest of the description in is HTML. We can probably find a better solution and do this whenever we're parsing the files and only do at build time.
 * TODO: Move this operation to the parser.
 * I don't want to do this in there, because I do not want to change the data that we get back from the payouts endpoints.
 *
 */
export function replaceBackticksWithCodeTags(text: string): string {
  // Replace backticks with <code> tags
  return text.replace(/`(.*?)`/g, '<code>$1</code>');
}
